import React from "react";
import styled from "styled-components";

const fontsizes = {
  xxxlarge: "30px",
  xxlarge: "26px",
  xlarge: "24px",
  large: "22px",
  tabTitle: "18px",
  title: "16px",
  content: "14.5px",
  normal: "14.5px",
  small: "13px",
  xsmall: "11.5px",
};

const family = {
  bold: "NotoSansCJKkr-Bold",
  medium: "NotoSansCJKkr-Medium",
  regular: "NotoSansCJKkr-Regular",
};

const colors = {
  main: "#32905E",
  main2: "#2A6245",

  border: "#F3D802",
  bgBlack: "#4C4B4B",
  bgGray: "#faf8f8", // 연한 그레이
  bgGray2: "#F5F2F2", // 1보다는 진하지만 연함
  bgBlue: "#E4F1FC",
  bgGreen: "#EBFDED",
  bgRed: "#FFF1F1",
  bgOrange: "#FFF0DC",

  barGray: "#e6e6e6",
  barGray2: "#d6d6d6", //line으로 수정예정
  barDarkGray: "#7d7d7d", //line으로 수정예정

  btnGray: "#BEBEBE",

  fontMain: "#191919", // 검은색 글씨
  fontGray: "#7D7D7D", // 회색 글씨
  fontLightGray: "#AFAEAE", // placeholder
  fontDarkGray: "#686868",
  fontGreen: "#32905E", //  더 진한 녹색
  fontDarkGreen: "#3A8477", // 어두운 녹색
  fontBlue: "#5C65FE",
  fontBlue2: "#3D62AC",
  fontRed: "#F5838A",
  fontWhite: "#ffffff",
  fontYellow: "#FFB300",
  fontYellow2: "#FFF700",
  fontOrange: "#FF9100",
  fontLightGreen: "#77CFC2",
  lineGray: "#E6E6E6",
  lineDarkGray: "#7d7d7d",
  fontAqua: "#1cc8d5",
  fontEmerald: "#51DBC3",
};
export const Content_Text = styled.span`
  font-size: ${(props) =>
    props.$large
      ? "22px"
      : props.$xlarge
      ? "24px"
      : props.$xmlarge
      ? "32px"
      : props.$xxlarge
      ? "40px"
      : props.$extra
      ? "50px"
      : props.$small
      ? "16px"
      : props.$xsmall
      ? "15px"
      : props.$xxsmall
      ? "12px"
      : props.$xxslarge
      ? "36px"
      : "20px"};
  font-weight: ${(props) =>
    props.$xxbold
      ? 800
      : props.$xbold
      ? 700
      : props.$bold
      ? 500
      : props.$regular
      ? 300
      : 400};
  color: ${(props) =>
    props.$main
      ? colors.main
      : props.$main2
      ? colors.main2
      : props.$blue
      ? colors.fontBlue
      : props.$blue2
      ? colors.fontBlue2
      : props.$red
      ? colors.fontRed
      : props.$gray
      ? colors.fontGray
      : props.$green
      ? colors.fontGreen
      : props.$lightGray
      ? colors.fontLightGray
      : props.$darkGray
      ? colors.fontDarkGray
      : props.$white
      ? colors.fontWhite
      : props.$yellow
      ? colors.fontYellow
      : props.$yellow2
      ? colors.fontYellow2
      : props.$darkGreen
      ? colors.fontDarkGreen
      : props.$fontLightGreen
      ? colors.fontLightGreen
      : props.$aqua
      ? colors.fontAqua
      : props.$emerald
      ? colors.fontEmerald
      : colors.fontMain};
  @media (max-width: 800px) {
    font-size: ${(props) =>
      props.$large
        ? "13px"
        : props.$xlarge
        ? "14px"
        : props.$xmlarge
        ? "18px"
        : props.$xxlarge
        ? "22px"
        : props.$extra
        ? "24px"
        : props.$small
        ? "11px"
        : props.$xsmall
        ? "10px"
        : props.$xxsmall
        ? "9px"
        : props.$xxslarge
        ? "20px"
        : "12px"};
  }
`;
const theme = {
  fontsizes,
  family,
  colors,
  Content_Text,
};
export default theme;
